<template>
  <section class="section container pt-0">
    <poker-tournaments-datatable />
  </section>
</template>

<script>
import PokerTournamentsDatatable from "./poker_tournaments_datatable/Index.vue";

export default {
  name: "PokerTournamentsIndex",
  components: { PokerTournamentsDatatable },
  data() {
    return {
      is_loading: false,
    };
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
